module.exports = __webpack_public_path__ + "static/ml_hero_blog-c5cc182a50399fe27c00c156de9d8ed0.svg";